$(function() {

    var $updateForm = $("#updateForm");

//Common Click Handler
    $("input.sf-checkbox-click").on("click", function (e) {
        e.stopPropagation();
        console.log(".sf-click");
        var $input = $(this);
        var inputName = $input.attr("name");
        var $updateInput = $updateForm.find("input[name=" + inputName + "]")
        if ($updateInput.length === 0) {
            $("<input>").attr({
                type: "hidden",
                name: inputName,
                value: $input.prop("checked")
            }).appendTo($updateForm);
        } else {
            $updateInput.val($input.prop("checked"));
        }
        $updateForm.submit();
    });

    $(".sf-clearSelection").on("click", function (e) {
        e.stopPropagation();
        var $button = $(this);
        var targetClass = $button.data("target");
        $(targetClass).find('input').each(function (index, input) {
            console.log('input:', input);
            var $input = $(input);
            var inputName = $input.attr("name");
            var $updateInput = $updateForm.find("input[name=" + inputName + "]");
            if ($updateInput.length === 0) {
                $("<input>").attr({
                    type: "hidden",
                    name: inputName,
                    value: null
                }).appendTo($updateForm);
            } else {
                $updateInput.val(null);
            }
            $updateForm.submit();
        })
    });

    // Readmore scripts
    if($('.js_readmore').length){
        $('.js_readmore').each(function(){
            var moreLink = $(this).data('more');
            var lessLink = $(this).data('less');
            var collapseHeight = ($(this).data('height')!='')?$(this).data('height'):0;
            $(this).find('.js_readmoreTarget').readmore({
                speed: 300,
                collapsedHeight: collapseHeight,
                moreLink: '<a class="accBtn" href="#">' + moreLink + '</a>',
                lessLink: '<a class="accBtn" href="#">' + lessLink + '</a>'
            });
        })
    }

});